import React, { useState } from 'react';
import styles from './ManagerInsuranceCompaniesBatchesMenu.module.scss';
import { useDisclose } from '../../../../../Modal/Hooks/useDisclose';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import ManagerInsuranceCompaniesBatchCreateModal from '../ManagerInsuranceCompaniesBatchCreate/ManagerInsuranceCompaniesBatchCreateModal';
import ManagerInsuranceCompaniesBatchCreateTableModal from '../ManagerInsuranceCompaniesBatchCreateTable/ManagerInsuranceCompaniesBatchCreateTableModal';
import { InsuranceCompanyBatch } from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';

interface Props {
	reloadData: () => void;
}

const ManagerInsuranceCompaniesBatchesMenu = ({ reloadData }: Props) => {
	const [createdBatches, setCreatedBatches] = useState<InsuranceCompanyBatch[]>(
		[],
	);

	const {
		isOpen: isCreateBatchModalOpen,
		onOpen: onCreateBatchModalOpen,
		onClose: onCreateBatchModalClose,
	} = useDisclose();

	const {
		isOpen: isBatchResultModalOpen,
		onOpen: onBatchResultModalOpen,
		onClose: onBatchResultModalClose,
	} = useDisclose();

	const onCreateBatchSuccess = (batches: InsuranceCompanyBatch[]) => {
		setCreatedBatches(batches);
		onCreateBatchModalClose();
		onBatchResultModalOpen();
	};

	const handleBatchResultModalClose = () => {
		onBatchResultModalClose();
		reloadData();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<LinkButton
					title={'component.insuranceCompanyBatch.createForm.title'}
					theme={Theme.BLUE}
					onClick={onCreateBatchModalOpen}
					className={styles.item}
				/>
			</div>
			{isCreateBatchModalOpen && (
				<ManagerInsuranceCompaniesBatchCreateModal
					isOpen
					onSuccess={onCreateBatchSuccess}
					reloadData={reloadData}
					onClose={onCreateBatchModalClose}
				/>
			)}
			{isBatchResultModalOpen && (
				<ManagerInsuranceCompaniesBatchCreateTableModal
					isOpen
					batches={createdBatches}
					onClose={handleBatchResultModalClose}
				/>
			)}
		</>
	);
};

export default ManagerInsuranceCompaniesBatchesMenu;
